import styled from '@emotion/styled'
import { color } from 'styled-system'
import { Input } from '@chakra-ui/core'

export const StyledInput = styled(Input)`
  ${color}
  width: 15%;
`
